export default "__VITE_PUBLIC_ASSET__021031b4__"